import { useSyncExternalStore } from 'react';

import { getAppStatus, subscribeAppStatus } from './appStatus.js';

/** The app status (appStatus.js) as React state. */
export default function useAppStatus() {
    return useSyncExternalStore(subscribeAppStatus, getAppStatus, getAppStatus);
}
